import { formatDate } from "../../utils";

export default function BugReportDetail({ bug }) {
  return (
    <div className="bug-detail">
      <div className="bug-detail-header">
        <div className="bug-detail-title">
          <h2>Bug Report Details</h2>
          <div className={`status-badge ${bug.status}`}>
            {bug.status === "open" && "Open"}
            {bug.status === "in-progress" && "In Progress"}
            {bug.status === "resolved" && "Resolved"}
          </div>
        </div>

        <div className="bug-actions">
          <select className="status-select" defaultValue={bug.status}>
            <option value="open">Open</option>
            <option value="resolved">Resolved</option>
          </select>
          <button className="action-button">Update Status</button>
        </div>
      </div>

      <div className="bug-detail-content">
        <div className="bug-detail-section">
          <h3>Reporter Information</h3>
          <div className="detail-row">
            <div className="detail-label">Username:</div>
            <div className="detail-value">{bug.username}</div>
          </div>
          <div className="detail-row">
            <div className="detail-label">Email:</div>
            <div className="detail-value">{bug.email}</div>
          </div>
          <div className="detail-row">
            <div className="detail-label">Reported On:</div>
            <div className="detail-value">{formatDate(new Date(bug.date))}</div>
          </div>
        </div>

        <div className="bug-detail-section">
          <h3>Bug Information</h3>
          <div className="detail-row">
            <div className="detail-label">Bug Type:</div>
            <div className="detail-value">{bug.bugType}</div>
          </div>
          <div className="detail-row">
            <div className="detail-label">Severity:</div>
            <div className="detail-value">
              <span className={`severity-indicator ${bug.severity}`}></span>
              {bug.severity.charAt(0).toUpperCase() + bug.severity.slice(1)}
            </div>
          </div>
        </div>

        <div className="bug-detail-section">
          <h3>Details</h3>
          <div className="detail-text">{bug.details}</div>
        </div>

        {bug.criticalReason && (
          <div className="bug-detail-section">
            <h3>Critical Severity Reason</h3>
            <div className="detail-text">{bug.criticalReason}</div>
          </div>
        )}

        {bug.attachments?.length > 0 && (
          <div className="bug-detail-section">
            <h3>Attachments</h3>
            <div className="attachments-container">
              {bug.attachments.map((attachment, index) => (
                <div key={index} className="attachment-item">
                  <div className="attachment-preview">
                    <img
                      src={attachment.url || "/placeholder.svg"}
                      alt={attachment.name}
                    />
                  </div>
                  <div className="attachment-info">
                    <div className="attachment-name">{attachment.name}</div>
                    <a
                      href={attachment.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="download-link"
                    >
                      View Full Size
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
